import { render, staticRenderFns } from "./tzzwb.vue?vue&type=template&id=5409837e&scoped=true"
import script from "./tzzwb.vue?vue&type=script&lang=js"
export * from "./tzzwb.vue?vue&type=script&lang=js"
import style0 from "./tzzwb.vue?vue&type=style&index=0&id=5409837e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5409837e",
  null
  
)

export default component.exports